<template>
  <div
    style="
     display: flex;
     flex-wrap: wrap;
     align-items: center;
     justify-content: center;
     width: 100vw;
     z-index: 1000;
     height: 100vh;
     position: fixed;
     background-color: #000000"
    :onload="this.getQuotes()"
  >
    <div class="loader-new">
      <div class="container">
        <div class="loader-icon">
          <img src="/static/img/loader/loading-viewZzz.svg" height="30" />
        </div>
        <div class="line"></div>
        <div class="loader-quote">
          <p class="quoteText">{{currentQuote.text}}</p>
          <p class="quoteAuthor">{{currentQuote.author}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      quotes: [
        {
          author: "Lao Tzu",
          text:
            "A good traveler has no fixed plans, and is not intent on arriving."
        },
        {
          author: "Michael Bassey Johnson",
          text: "A good traveler is one who knows how to travel with the mind."
        },
        {
          author: "Tim Cahill",
          text: "A journey is best measured in friends rather than miles."
        },
        {
          author: "John Steinbeck",
          text:
            "A journey is like marriage. The certain way to be wrong is to think you control it."
        },
        {
          author: "Lao Tzu",
          text: "A journey of a thousand miles begins with a single step."
        },
        {
          author: "John A. Shedd",
          text:
            "A ship in a harbor is safe, but it not what ships are built for."
        },
        {
          author: "Aesop",
          text: "Adventure is worthwhile."
        },
        {
          author: "Unknown",
          text: "Adventure may hurt you but monotony will kill you."
        },
        {
          author: "Martin Buber",
          text:
            "All journeys have secret destinations of which the traveler is unaware."
        },
        {
          author: "JRR Tolkien",
          text:
            "All that is gold does not glitter; just as not all those who wander are lost."
        },
        {
          author: "Wolf, an Appalachian Trail Hiker",
          text: "All you need to know is that it’s possible."
        },
        {
          author: "Unknown",
          text:
            "Better to see something once than hear about it a thousand times."
        },
        {
          author: "Lovelle Drachman",
          text: "Blessed are the curious for they shall have adventures."
        },
        {
          author: "Unknown",
          text: "Collect Moment, Not Things."
        },
        {
          author: "Unknown",
          text: "Dare to live the life you’ve always wanted."
        },
        {
          author: "Ralph Waldo Emerson",
          text:
            "Do not follow where the path may lead. Go instead where there is no path and leave a trail."
        },
        {
          author: "Shane L. Koyczan",
          text:
            "Don’t let your luggage define your travels, each life unravels differently."
        },
        {
          author: "Unknown",
          text: "Don’t listen to what they say. Go see."
        },
        {
          author: "Mohammed",
          text:
            "Don’t tell me how educated you are, tell me how much you have traveled."
        },
        {
          author: "Ma Jian",
          text:
            "Everything I was I carry with me, everything I will be lies waiting on the road ahead."
        },
        {
          author: "Unknown",
          text:
            "Go, fly, roam, travel, voyage, explore, journey, discover, adventure."
        },
        {
          author: "William Blake",
          text: "Great things are done when men and mountains meet."
        },
        {
          author: "Mary Anne Radmacher",
          text:
            "I am not the same having seen the moon shine on the other side of the world."
        },
        {
          author: "Paulo Coelho",
          text:
            "I can speak to my soul only when the two of us are off exploring deserts or cities or mountains or roads."
        },
        {
          author: "Mark Twain",
          text:
            "I have found out that there ain’t no surer way to find out whether you like people or hate them than to travel with them."
        },
        {
          author: "Susan Sontag",
          text: "I haven’t been everywhere, but it’s on my list."
        },
        {
          author: "Derek Walcott",
          text: "I read; I travel; I become."
        },
        {
          author: "Thomas Jefferson",
          text:
            "I think one travels more usefully when they travel alone because they reflect more."
        },
        {
          author: "Caskie Stinnett",
          text: "I travel a lot; I hate having my life disrupted by routine."
        },
        {
          author: "Carew Papritz",
          text:
            "I travel because it makes me realize how much I haven’t seen, how much I’m not going to see, and how much I still need to see."
        },
        {
          author: "Roman Payne",
          text:
            "I wandered everywhere, through cities and countries wide. And everywhere I went, the world was on my side."
        },
        {
          author: "A. Redmerski",
          text:
            "I wonder if the ocean smells different on the other side of the world."
        },
        {
          author: "John Green",
          text:
            "I’m in love with cities I’ve never been to and people I’ve never met."
        },
        {
          author: "Santosh Kalwar",
          text:
            "If life is a journey then let my soul travel and share your pain."
        },
        {
          author: "James Michener",
          text:
            "If you reject the food, ignore the customs, fear the religion and avoid the people, you might better stay at home."
        },
        {
          author: "Paul Coelho",
          text:
            "If you think adventures are dangerous, try routine: It’s Lethal."
        },
        {
          author: "Unknown",
          text: "In the end, we only regret the chances we didn’t take."
        },
        {
          author: "Unknown",
          text: "It feels good to be lost in the right direction."
        },
        {
          author: "Ursula K. Le Guin",
          text:
            "It is good to have an end to journey toward, but it is the journey that matters in the end."
        },
        {
          author: "Henry David Thoreau",
          text: "It’s not what you look at that matters. It’s what you see."
        },
        {
          author: "Helen Keller",
          text: "Life is either a daring adventure or nothing at all."
        },
        {
          author: "Unknown",
          text: "Life is short and the world is wide."
        },
        {
          author: "Benjamin Disraeli",
          text:
            "Like all great travelers, I have seen more than I remember, and remember more than I have seen."
        },
        {
          author: "Oscar Wilde",
          text: "Live life with no excuses, travel with no regret."
        },
        {
          author: "Stephen Covey",
          text: "Live your life by a compass not a clock."
        },
        {
          author: "Tennessee Williams",
          text: "Make voyages. Attempt them. There’s nothing else."
        },
        {
          author: "Andre Gide",
          text:
            "Man cannot discover new oceans unless he has the courage to lose sight of the shore."
        },
        {
          author: "Jodi Picoult",
          text:
            "Maybe you had to leave in order to miss a place; maybe you had to travel to figure out how beloved your starting point was."
        },
        {
          author: "Roman Payne",
          text:
            "Never did the world make a queen of a girl who hides in houses and dreams without traveling."
        },
        {
          author: "Amin Maalouf",
          text:
            "Never hesitate to go far away, beyond all seas, all frontiers, all countries, all beliefs."
        },
        {
          author: "Banana Yoshimoto",
          text:
            "No matter where you are, you’re always a bit on your own, always an outsider."
        },
        {
          author: "Lin Yutang",
          text:
            "No one realizes how beautiful it is to travel until he comes home and rests his head on his old, familiar pillow."
        },
        {
          author: "J.R.R. Tolkien",
          text: "Not all those who wander are lost."
        },
        {
          author: "Unknown",
          text: "Oh Darling, Let’s Be Adventurers."
        },
        {
          author: "Dr. Seuss",
          text: "Oh the places you’ll go."
        },
        {
          author: "Dalai Lama",
          text: "Once a year, go someplace you’ve never been before."
        },
        {
          author: "Michael Palin",
          text:
            "Once the travel bug bites there is no known antidote, and I know that I shall be happily infected until the end of my life."
        },
        {
          author: "Henry Miller",
          text:
            "One’s destination is never a place, but a new way of seeing things."
        },
        {
          author: "John Steinbeck",
          text: "People don’t take trips, trips take people."
        },
        {
          author: "Unknown",
          text:
            "Quit your job, buy a ticket, get a tan, fall in love, never return."
        },
        {
          author: "Roy M. Goodman",
          text:
            "Remember that happiness is a way of travel – not a destination."
        },
        {
          author: "Jack Kerouac",
          text: "So shut up, live, travel, adventure, bless and don’t be sorry."
        },
        {
          author: "Erol Ozan",
          text: "Some beautiful paths can’t be discovered without getting lost."
        },
        {
          author: "Chief Seattle",
          text: "Take only memories, leave only footprints."
        },
        {
          author: "Agnes Repplier",
          text: "The impulse to travel is one of the hopeful symptoms of life."
        },
        {
          author: "Dan Eldon",
          text: "The journey is the destination."
        },
        {
          author: "T.S. Eliot",
          text: "The journey not the arrival matters."
        },
        {
          author: "Anna Quindlen",
          text:
            "The life you have led doesn’t need to be the only life you have."
        },
        {
          author: "Henry David Thoreau",
          text:
            "The man who goes alone can start today, but he who travels with another must wait till that other is ready."
        },
        {
          author: "Wallace Stevens",
          text:
            "The most beautiful in the world is, of course, the world itself."
        },
        {
          author: "G.K. Chesterton",
          text:
            "The traveler sees what he sees. The tourist sees what he has come to see."
        },
        {
          author: "Augustine of Hippo",
          text:
            "The world is a book and those who do not travel read only one page."
        },
        {
          author: "Ralph Waldo Emerson",
          text: "The world makes way for the man who knows where he is going."
        },
        {
          author: "Robert Louis Stevenson",
          text:
            "There are no foreign lands. It is the traveler only who is foreign."
        },
        {
          author: "Paulo Coelho",
          text: "This wasn’t a strange place; it was a new one."
        },
        {
          author: "Ralph Waldo Emerson",
          text:
            "Though we travel the world over to find the beautiful, we must carry it with us, or we find it not."
        },
        {
          author: "Freya Stark",
          text:
            "To awaken quite alone in a strange town is one of the pleasantest sensations in the world."
        },
        {
          author: "Aldous Huxley",
          text:
            "To travel is to discover that everyone is wrong about other countries."
        },
        {
          author: "Hans Christian Andersen",
          text: "To travel is to live."
        },
        {
          author: "Elizabeth Gilbert",
          text: "To travel is worth any cost or sacrifice."
        },
        {
          author: "Alex Garland",
          text:
            "Tourists went on holidays while travelers did something else. They traveled."
        },
        {
          author: "Jalaluddin Rumi",
          text: "Travel brings power and love back into your life."
        },
        {
          author: "Joe Abercrombie",
          text:
            "Travel brings wisdom only to the wise. It renders the ignorant more ignorant than ever."
        },
        {
          author: "Marty Rubin",
          text:
            "Travel doesn’t become adventure until you leave yourself behind."
        },
        {
          author: "Claire Fontaine",
          text:
            "Travel empties out everything you’ve into the box called your life, all the things you accumulate to tell you who you are."
        },
        {
          author: "David Mitchell",
          text: "Travel far enough, you meet yourself."
        },
        {
          author: "Mark Twain",
          text: "Travel is fatal to prejudice, bigotry, and narrow-mindedness."
        },
        {
          author: "Miriam Beard",
          text:
            "Travel is more than the seeing of sights; it is a change that goes on, deep and permanent, in the ideas of living."
        },
        {
          author: "Unknown",
          text: "Travel is the only thing you buy that makes you richer."
        },
        {
          author: "Thomas Fuller",
          text: "Travel makes a wise man better, and a fool worse."
        },
        {
          author: "Gustave Flaubert",
          text:
            "Travel makes one modest. You see what a tiny place you occupy in the world"
        },
        {
          author: "Ibn Battuta",
          text:
            "Traveling – it leaves you speechless, then turns you into a storyteller."
        },
        {
          author: "Gayle Foreman",
          text:
            "Traveling’s not something you’re good at. It’s something you do. Like Breathing."
        },
        {
          author: "Robert Frost",
          text:
            "Two roads diverged in a wood and I – I took the one less traveled by, and that has made all the difference."
        },
        {
          author: "Ray Bradbury",
          text:
            "We travel for romance, we travel for architecture, and we travel to be lost."
        },
        {
          author: "Anonymous",
          text: "We travel not to escape life, but for life not to escape us."
        },
        {
          author: "Anais Nin",
          text:
            "We travel, some of us forever, to seek other states, other lives, other souls."
        },
        {
          author: "Hilaire Belloc",
          text: "We wander for distraction but we travel for fulfillment."
        },
        {
          author: "Jack Kerouac",
          text: "We wandered in a frenzy and a dream."
        },
        {
          author: "Clifton Fadiman",
          text:
            "When you travel, remember that a foreign country is not designed to make you comfortable. It is designed to make its own people comfortable."
        },
        {
          author: "Vera Nazarian",
          text:
            "Whenever you go on a trip to visit foreign lands or distant places, remember that they are all someone’s home and backyard."
        },
        {
          author: "Anita Desai",
          text: "Wherever you go becomes a part of you somehow."
        },
        {
          author: "Neil Gaiman",
          text: "Wherever you go, you take yourself with you."
        },
        {
          author: "Frank Herbert",
          text:
            "Without new experiences, something inside of us sleeps. The sleeper must awaken."
        },
        {
          author: "Unknown",
          text: "Work, Travel, Save, Repeat."
        },
        {
          author: "Kirsten Hubbard",
          text:
            "You can’t control the past, but you can control where you go next."
        },
        {
          author: "George Bernard Shaw",
          text: "I dislike feeling at home when I am abroad."
        },
        {
          author: "Henry David Thoreau",
          text: "Not until we are lost do we begin to understand ourselves."
        },
        {
          author: "Mohamed",
          text:
            "Don’t tell me how educated you are, tell me how much you travelled."
        },
        {
          author: "Kurt Vonnegut",
          text: "Bizarre travel plans are dancing lessons from God."
        },
        {
          author: "Martin Buber",
          text:
            "All journeys have secret destinations of which the traveller is unaware."
        },
        {
          author: "Paul Theroux",
          text:
            "Tourists don’t know where they’ve been, travellers don’t know where they’re going."
        },
        {
          author: "Robert Louis Stevenson",
          text:
            "There are no foreign lands. It is the traveller only who is foreign."
        },
        {
          author: "Albert Einstein",
          text: "I love to travel, but hate to arrive."
        },
        {
          author: "Hilaire Belloc",
          text: "We wander for distraction, but we travel for fulfillment."
        },
        {
          author: "Benjamin Disraeli",
          text: "Travel teaches toleration."
        },
        {
          author: "Ray Bradbury",
          text: "Half of the fun of travel is the aesthetic of lostness."
        },
        {
          author: "Ben Francia",
          text: "Great things never came from comfort zones."
        },
        {
          author: "Maya Angelou",
          text:
            "If you are always trying to be normal, you will never know how amazing you can be."
        },
        {
          author: "Unknown",
          text: "Fear is only temporary. Regrets last forever."
        },
        {
          author: "Neale Donald Walsch",
          text: "Life begins at the end of your comfort zone."
        },
        {
          author: "David McCullough Jr.",
          text:
            "Climb the mountain so you can see the world, not so the world can see you."
        },
        {
          author: "Alexander Sattler",
          text:
            "I would rather own a little and see the world than own the world and see a little of it."
        },
        {
          author: "William Langewiesche",
          text: "So much of who we are is where we have been."
        },
        {
          author: "Paulo Coelho",
          text: "Travel is never a matter of money but of courage."
        },
        {
          author: "Shakespeare",
          text: "The earth has music for those who listen."
        },
        {
          author: "Unknown",
          text: "Do more things that make you forget to check your phone."
        },
        {
          author: "Carew Papritz",
          text: "I travel because I become uncomfortable being too comfortable."
        },
        {
          author: "Peter McWilliams",
          text: "Nothing adventured, nothing attained."
        },
        {
          author: "Seth Godin",
          text: "If it scares you, it might be a good thing to try."
        },
        {
          author: "Franklin D. Roosevelt",
          text: "Above all, try something."
        },
        {
          author: "Unknown",
          text: "Good things come to those who book flights."
        },
        {
          author: "Edith Wharton",
          text:
            "One of the great things about travel is that you find out how many good, kind people there are."
        },
        {
          author: "Unknown",
          text:
            "If you look like your passport photo, you probably need the trip."
        },
        {
          author: "Rachel Wolchin",
          text:
            "If we were meant to stay in one place, we’d have roots instead of feet."
        },
        {
          author: "Unknown",
          text: "My favourite thing is to go where I’ve never been."
        },
        {
          author: "Unknown",
          text: "It’s bad manners to keep an adventure waiting."
        },
        {
          author: "Ray Bradbury",
          text:
            "We travel for romance, we travel for architecture, we travel to be lost."
        },
        {
          author: "Ernest Hemingway",
          text: "Never go on trips with anyone you do not love."
        },
        {
          author: "Unknown",
          text: "Some things weren’t meant to be tamed. For example, YOU."
        },
        {
          author: "Ben Franklin",
          text:
            "Either write something worth reading or do something worth writing."
        },
        {
          author: "John Steinbeck",
          text:
            "I wonder how many people I’ve looked at all my life and never seen."
        },
        {
          author: "Unknown",
          text:
            "May you never be too busy to stop and breathe under a palm tree."
        },
        {
          author: "Unknown",
          text: "Don’t quit your daydream."
        },
        {
          author: "Ernest Hemingway",
          text:
            "The best way to find out if you can trust somebody is to trust them."
        },
        {
          author: "Winston Churchill",
          text:
            "I like things to happen. And if they don’t happen, I like to make them happen."
        },
        {
          author: "Unknown",
          text: "Surround yourself with people who get it."
        },
        {
          author: "Terry Pratchett",
          text:
            "Coming back to where you started is not the same as not leaving."
        },
        {
          author: "Paul Theroux",
          text: "Travel is glamorous only in retrospect."
        },
        {
          author: "Aerin Lauder",
          text:
            "To understand what’s going on in the world, you have to see the world."
        },
        {
          author: "Ugo Eze",
          text:
            "Be careful who you make memories with. Those things can last a lifetime."
        },
        {
          author: "Walt Whitman",
          text:
            "Not I, not anyone else, can travel that road for you. You must travel it for yourself."
        },
        {
          author: "Shanti",
          text:
            "At the end of the day, your feet should be dirty, your hair should be messy and your eyes sparkling."
        },
        {
          author: "Your Passport",
          text: "You’ll never know until you go."
        },
        {
          author: "Unknown",
          text:
            "Travelling is about finding those things that you never knew you were looking for."
        }
      ]
    };
  },
  methods: {
    getQuotes() {
      let x = Math.floor(Math.random() * this.quotes.length);
      this.currentQuote = this.quotes[x];
    }
  }
};
</script>
<style lang="scss">
.quoteText {
  font-family: "MontSerrat-Regular";
  font-size: 18px;
  color: #ffffff;
}

.quoteAuthor {
  font-family: "MontSerrat-Regular";
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}
.loader-new {
  height: 280px;
  width: 550px;
  padding: 10px;
  transform: translate(25%);
  .container {
    display: flex;
    height: 100%;
    width: 100%;
    .loader-icon {
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: 25px;
    }
    .loader-quote {
      color: white;
      display: flex;
      justify-content: center;
      height: 100%;
      flex-direction: column;
      text-align: left;
      padding-left: 25px;
    }
    .line {
      height: 100%;
      width: 2px;
      background-color: white;
      height: 100%;
    }
  }
  @media only screen and (max-width: 768px) {
    height: auto;
    max-width: 280px;
    transform: translate(0);
    .container {
      flex-wrap: wrap;
      height: auto;
      .loader-icon {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        padding-right: 0px;
        padding-bottom: 25px;
        justify-content: center;
      }
      .loader-quote {
        height: auto;
        width: 100%;
        flex-direction: column;
        text-align: center;
        padding-left: 0px;
        padding-top: 15px;
      }
      .line {
        height: 2px;
        width: 100%;
        background-color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// loader.vue?749539f6